import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import QueueAnim from 'rc-queue-anim'
import { Button } from './Button'
import Icon from './Icon'
import zIndex from '../../utils/zIndexScale'
import { FormatText } from '../../i18n/util'

const Layer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${zIndex.modal};
  background: rgba(0, 0, 0, 0.5);
`

const Wrapper = styled.div`
  color: ${({ theme }) => theme.fontColor || 'black'};
  min-width: 320px;
  /* max-width: 450px; */
  padding: 30px;
  box-sizing: border-box;
  background: ${({ theme }) => theme.popupBg || '#fff'};
  box-shadow: ${({ theme }) => theme.boxShadow};
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
`

const Content = styled.div`
  padding: 20px 0;
  font-size: 16px;

  & a {
    &,
    &:hover,
    &:active,
    &:visited {
      color: inherit !important;
      text-decoration: underline;
    }
  }
`

const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: ${props => props.align};
`

const Close = styled.div`
  position: absolute;
  top: 5px;
  right: 8px;
  cursor: pointer;
  color: #848e9c;
  &:hover {
    color: #f0b90b;
  }
`

const ModalButton = styled(Button)`
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
`

const CancelButton = styled(Button)`
  height: 34px;
  line-height: 34px;
  background: #fff;
  border: 1px solid #f0b90b;
  color: #f0b90b;
  margin-right: 10px;
  box-sizing: border-box;
`

class Modal extends PureComponent {
  static propTypes = {
    closeText: PropTypes.arrayOf(PropTypes.string, PropTypes.node),
    title: PropTypes.string,
    children: PropTypes.element,
    close: PropTypes.func,
    next: PropTypes.func,
    closeAlign: PropTypes.string,
    bgColor: PropTypes.string,
    cancelButton: PropTypes.bool,
    hideButton: PropTypes.bool,
  }

  static defaultProps = {
    closeText: <FormatText value="common.close" />,
    cancelButton: false,
    title: '',
    children: null,
    closeAlign: 'flex-end',
    bgColor: '',
    close: null, // no close button if not given
    next: null,
    hideButton: false,
  }

  componentDidMount() {
    window.document.body.addEventListener('keydown', this._keydown)
  }

  componentWillUnmount() {
    window.document.body.removeEventListener('keydown', this._keydown)
  }

  _keydown = ev => {
    const { close } = this.props
    if (ev.keyCode === 27) {
      close && close()
    }
  }

  render() {
    const {
      closeText,
      title,
      close,
      children,
      closeAlign,
      next,
      cancelButton,
      hideButton,
      bgColor,
    } = this.props
    return (
      <QueueAnim animConfig={[{ opacity: [1, 0] }]}>
        <Layer key="1">
          <QueueAnim leaveReverse={true} delay={100} type={['top', 'bottom']}>
            <Wrapper key="1" bgColor={bgColor}>
              <Title>{title}</Title>
              <Content>{children}</Content>
              {!hideButton && (
                <Footer align={closeAlign}>
                  {cancelButton && close && (
                    <CancelButton onClick={close}>
                      <span>Cancel</span>
                    </CancelButton>
                  )}
                  {(next || close) && (
                    <ModalButton onClick={next || close} width="100px">
                      <span>{closeText}</span>
                    </ModalButton>
                  )}
                </Footer>
              )}
              {close ? (
                <Close onClick={close}>
                  <Icon type="close" size="18" />
                </Close>
              ) : null}
            </Wrapper>
          </QueueAnim>
        </Layer>
      </QueueAnim>
    )
  }
}

export default Modal
